import { combineReducers } from 'redux'
import { injectReducer } from '../../../../store/reducers'

export default (store) => ({
  path: 'productStatus',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Bulk = require('./containers/ProductStatusContainer').default
      const bulkReducer = require('./modules/productStatus').default

      /*  Add the reducer to the store on key 'workflow'  */
      injectReducer(store, {
        key: 'productStatus',
        reducer: combineReducers({
          button: bulkReducer
        })
      })

      /*  Return getComponent   */
      cb(null, Bulk)

    /* Webpack named bundle   */
    }, 'productStatus')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Button/routes/ProductStatus/index.js